/* eslint-disable react/no-unknown-property */
import React from 'react';

interface PauseIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const PauseIcon: React.FC<PauseIconProps> = ({
  width = 16,
  height = 16,
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_36937_576398)">
      <path
        d="M6.00098 3.99835H4.66504V12.0013H6.00098L6.00195 12.0003V4.00031L6.00098 3.99835ZM7.33203 12.0003C7.33194 12.3534 7.19107 12.6921 6.94141 12.9417C6.69169 13.1913 6.3531 13.3314 6 13.3314H4.66699C4.31381 13.3314 3.97435 13.1914 3.72461 12.9417C3.47505 12.6921 3.33505 12.3533 3.33496 12.0003V4.00031C3.33496 3.64712 3.47487 3.30766 3.72461 3.05792C3.97435 2.80819 4.31381 2.66827 4.66699 2.66827H6C6.35303 2.66827 6.6917 2.80839 6.94141 3.05792C7.19114 3.30766 7.33203 3.64712 7.33203 4.00031V12.0003Z"
        fill="currentColor"
      />
      <path
        d="M11.3342 3.99835H9.99829V12.0013H11.3342L11.3352 12.0003V4.00031L11.3342 3.99835ZM12.6653 12.0003C12.6652 12.3534 12.5243 12.6921 12.2747 12.9417C12.0249 13.1913 11.6864 13.3314 11.3333 13.3314H10.0002C9.64707 13.3314 9.3076 13.1914 9.05786 12.9417C8.8083 12.6921 8.6683 12.3533 8.66821 12.0003V4.00031C8.66821 3.64712 8.80813 3.30766 9.05786 3.05792C9.3076 2.80819 9.64706 2.66827 10.0002 2.66827H11.3333C11.6863 2.66827 12.025 2.80839 12.2747 3.05792C12.5244 3.30766 12.6653 3.64713 12.6653 4.00031V12.0003Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_36937_576398">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
